import React from 'react';
import PropTypes from 'prop-types';

const EmptyState = ({ icon, description, cta, href }) => (
  <div className="box box--simple box--loose box--light-bg text-center">
    <img className="margin-bottom" alt="" src={icon} width="72" />

    <h3>Yay!</h3>

    <p>{description}</p>

    {cta &&
      href && (
        <a className="button" href={href} target="_blank">
          {cta}
        </a>
      )}
  </div>
);

EmptyState.propTypes = {
  icon: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  cta: PropTypes.string,
  href: PropTypes.string
};

EmptyState.defaultProps = {
  cta: null,
  href: null
};

export default EmptyState;



// WEBPACK FOOTER //
// ./src/components/Common/EmptyState/EmptyState.js